import React, { createContext } from 'react';

import type { GroupContainer } from 'contexts/datamodel/DataModelContext';

interface GroupContext {
  group: GroupContainer;
}

const DEFAULT_STATE: GroupContext = {
  group: {
    type: 'Group',
    groupId: '',
    isGroupEnabled: true,
    collection: []
  } as GroupContainer
};

interface ContextMenuActionsProviderProps {
  group: GroupContainer;
  children: React.ReactNode;
}

export const GroupContext = createContext(DEFAULT_STATE);

export const GroupProvider = ({ group, children }: ContextMenuActionsProviderProps) => {
  const value = { group };
  return <GroupContext.Provider value={value}>{children}</GroupContext.Provider>;
};
